import React from 'react'
import Logo from '../../layout/Logo/index.jsx'
import User from '../../../services/user.jsx'
import i18n from '../../../services/i18n.jsx'
import Loader from '../../layout/loader.jsx'

import style from "./index.module.scss";
import Helpers from '../../../services/helpers.jsx'

class Login extends React.Component {
	constructor(props) {
		super(props);
		this.login = this.login.bind(this)
		this.resetPassword = this.resetPassword.bind(this)
		this.state = {
			email: '',
			password: '',
			loading: false
		}
	}

	// On component mount, add class on body
	componentDidMount() {
		document.body.classList.add('fullscreen');
	}

	// On component unmount, remove class on body
	componentWillUnmount() {
		document.body.classList.remove('fullscreen');
	}

	// User login
	login(event) {
		this.setState({ loading: true })
		event.preventDefault();

		User.login({
			email: this.state.email,
			password: this.state.password
		}).then(result => {
			this.setState({ loading: false })
			const { history } = this.props;
			
			if (result?.mustResetPassword) {
				history.push(`/reset-password?token=${result.passwordResetToken}`);
				return;
			}
			
			if (Helpers.isCurator(result?.role)){
				window.location.href = '/assets';
			} else {
				window.location.href = "/";
			}
		}).catch((err) => {
			console.log(err)
			this.setState({ error: true, loading: false })
		});
	}

	resetPassword(){
		this.props.history.push('/reset')
	}


	render() {
		return <div className={style?.login}>
			<div className={style?.["form-wrapper"]}>
				<div className={style?.form}>
					<div className={style?.logo}>
						<Logo />
					</div>
					<div className={`${style?.["block"]} block`}>
						{
							this.state.loading ? 
								<Loader /> : <>
									<h2>{ i18n.t('LOGIN_FORM_TITLE') }</h2>
									{ this.state.error && <p>Email or password not recognized, please try again</p> }
									<form onSubmit={this.login} className={`fields`}>
										<div className={`${style?.field} field`}>
											<label>{ i18n.t('FIELD_EMAIL') }</label>
											<input type="email" required placeholder={ i18n.t('FIELD_EMAIL_PLACEHOLDER') } value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} />
										</div>
										<div className={`${style?.field} field`}>
											<label>{ i18n.t('FIELD_PASSWORD') }</label>
											<input type="password" required placeholder={ i18n.t('FIELD_PASSWORD_PLACEHOLDER') } value={this.state.password} onChange={(e) => this.setState({ password: e.target.value })} />
										</div>
										<button className="blue">{ i18n.t('LOGIN_FORM_SUBMIT') }</button>
									</form>
									<div onClick={this.resetPassword} className={style?.['forgot-link']}>
										{i18n.t("FORGOT_PASSWORD")}
									</div>
								</>
						}
					</div>
				</div>
			</div>
		</div>
	}
}

export default Login
